// extracted by mini-css-extract-plugin
export default {"chevron":"Chevron_chevron__XgCk1","up":"Chevron_up__QDTEw","down":"Chevron_down__gC-yz","left":"Chevron_left__OLkeI","right":"Chevron_right__w12WT"};